import auth0js from 'auth0-js'

const auth0 = new auth0js.WebAuth({
    domain: `${process.env.VUE_APP_AUTH0_DOMAIN}`,
    clientID: `${process.env.VUE_APP_AUTH0_CLIENT_ID}`,
    redirectUri: `${process.env.VUE_APP_PASSWORDLESS_REDIRECT_URI}`,
    responseType: 'token id_token',
    scope: 'openid profile email',
})

export function start(email) {
    return new Promise(function(resolve, reject){
        auth0.passwordlessStart(
            { connection: 'email', send: 'link', email: email }, function(err, resp){
                if(err) reject(err)
                else resolve(resp)
            })
    })
}

export function verify(hash) {
    return new Promise(function(resolve, reject){
        auth0.parseHash( { hash }, function(err, result) {
            if (err) reject(err)
            else resolve(result.idToken)
        })
    })
}
